module.exports = __webpack_public_path__ + "static/media/background.6442dc36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/background.png
// module id = 1164
// module chunks = 0